import ReportsVue from '@/views/sic/reports/reports.vue';

const basePath = '/sic/reports';
const role = 'sic'; // 角色身份

export const SIC_REPORTS_INDEX = 'sic-reports-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReportsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_REPORTS_INDEX,
      component: () => import(
        /* webpackChunkName: "reports" */
        `@/views/${role}/reports/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
